export default "__VITE_ASSET__BFvSBhIA__"